import { render, staticRenderFns } from "./PackingListStatusesCreateEdit.vue?vue&type=template&id=09c3a434&scoped=true&"
import script from "./PackingListStatusesCreateEdit.vue?vue&type=script&lang=js&"
export * from "./PackingListStatusesCreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./PackingListStatusesCreateEdit.vue?vue&type=style&index=0&id=09c3a434&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c3a434",
  null
  
)

export default component.exports